import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import ActionModalHeader, { DemoNote, customerName } from "./ActionModalHeader";
import { FLAGS, PLAN_NAMES } from "../../../utils/staticData";

// STATIC DESIGN — per-customer feature flag overrides on top of the plan defaults
interface FeatureOverridesModalProps { show: boolean; onHide: () => void; user: any }

// match "Growth", "Titan (free trial) Plan"… to a flag plan column when possible
const planKey = (planName: string = "") => PLAN_NAMES.find(p => planName.toLowerCase().includes(p.toLowerCase()));

const FeatureOverridesModal = ({ show, onHide, user }: FeatureOverridesModalProps) => {
  const [overrides, setOverrides] = useState<Record<string, string>>({});
  useEffect(() => { if (show) setOverrides({}); }, [show]);

  const plan = planKey(user?.user_plan_name);
  const changed = Object.values(overrides).filter(v => v !== "default").length;

  const save = () => {
    toast.info(`${changed} override${changed === 1 ? "" : "s"} saved · demo only, not saved`);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered contentClassName="cx">
      <ActionModalHeader icon="ri-toggle-line" title="Feature overrides" subtitle={`${customerName(user)} · on top of ${user?.user_plan_name || "plan"} defaults`} onClose={onHide} />
      <div style={{ padding: "14px 20px" }}>
        {FLAGS.map(f => (
          <div className="cx-orow" key={f.key}>
            <div style={{ minWidth: 0 }}>
              <div className="t">{f.name}</div>
              <div className="d">Plan default: {plan ? (f.plans[plan] ? "ON" : "OFF") : "—"}</div>
            </div>
            <div className="right">
              <select className="cx-select" style={{ height: 30, fontSize: 12 }} value={overrides[f.key] || "default"} onChange={(e) => setOverrides(o => ({ ...o, [f.key]: e.target.value }))}>
                <option value="default">Default</option>
                <option value="on">Force ON</option>
                <option value="off">Force OFF</option>
              </select>
            </div>
          </div>
        ))}
        <DemoNote />
      </div>
      <div style={{ padding: "0 20px 18px", display: "flex", justifyContent: "flex-end", gap: 8 }}>
        <button type="button" className="cx-btn cx-btn-light" onClick={onHide}>Cancel</button>
        <button type="button" className="cx-btn cx-btn-primary" onClick={save}>Save overrides</button>
      </div>
    </Modal>
  );
};

export default FeatureOverridesModal;
